export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-xl font-bold text-background-50 mb-4">
              黄瓜影院
            </h3>
            <p className="text-sm text-background-400 leading-relaxed">
              免费电视剧全集、最新剧集完整版、高清影视在线观看平台。海量片库涵盖电影大全，即点即播不缓冲，智能推荐助您快速找片，满足追剧需求。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-label text-sm font-semibold text-background-100 mb-4 uppercase tracking-wide">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: '平台特色', href: '#features' },
                { label: '剧集索引', href: '#index' },
                { label: '热门榜单', href: '#ranking' },
                { label: '精彩推荐', href: '#media' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Service */}
          <div>
            <h4 className="font-label text-sm font-semibold text-background-100 mb-4 uppercase tracking-wide">
              服务支持
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: '关于我们', href: '#about' },
                { label: '联系我们', href: '#contact' },
                { label: '移动观影', href: '#app' },
                { label: '最新动态', href: '#updates' },
                { label: '热门话题', href: '#topics' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Partners */}
          <div>
            <h4 className="font-label text-sm font-semibold text-background-100 mb-4 uppercase tracking-wide">
              合作伙伴
            </h4>
            <p className="text-sm text-background-500 leading-relaxed">
              黄瓜影院与多家优质内容方及技术平台保持紧密合作，持续为观众带来更丰富的影视资源和更流畅的观看体验。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 黄瓜影院 huanggua.tv 版权所有。本站内容仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span>高清在线观看</span>
            <span className="w-1 h-1 rounded-full bg-background-600"></span>
            <span>即点即播</span>
            <span className="w-1 h-1 rounded-full bg-background-600"></span>
            <span>智能推荐追剧</span>
          </div>
        </div>
      </div>
    </footer>
  );
}